import React from "react";
import styled, { css } from "styled-components";

import { themeColors } from "js/react/sharedStyles";
import ProBadge from "js/react/components/ProBadge";
import { UpgradePlanDialogType } from "../../MarketingDialogs/UpgradePlanDialog";

// Adding TextStyle here to avoid circular dependency issue with MediaDialog
export const TextStyle = css`
    font-weight: 600;
    letter-spacing: 0.5px;
    font-size: 18px;
    line-height: 120%;
`;

const StyledUIMenuItem = styled.div<{
    selected?: boolean
}>`
    display: flex;
    align-items: center;
    width: 100%;
    padding: 10px 15px;
    ${TextStyle};
    justify-content: space-between;

    ${({ selected }) => selected ? "background: #DBE9F0;" : ""};

    :hover {
      background: ${themeColors.hoverBlue};
      cursor: pointer;
    }
`;

const StyledIconTitle = styled.div`
    display: flex;
    gap:10px;
`;

interface UIMenuItemProps {
    selected: string
    id: string
    icon?: JSX.Element
    title: string
    onClick: () => void
    workspaceId?: string
    proBadgeAnalytics?: object
    updatePlanBadge?: boolean
}

const MediaImporterMenuItem = ({ selected, id, icon, title, onClick, workspaceId, proBadgeAnalytics, updatePlanBadge }: UIMenuItemProps) => (<StyledUIMenuItem
    selected={selected === id}
    id={id}
    onClick={onClick}>
    <StyledIconTitle>
        {icon}
        {title}
    </StyledIconTitle>
    {updatePlanBadge && <ProBadge
        show={updatePlanBadge}
        upgradeType={UpgradePlanDialogType.UPGRADE_PLAN_TO_TEAM}
        analytics={proBadgeAnalytics}
        workspaceId={workspaceId}
    />}
</StyledUIMenuItem>);

export default MediaImporterMenuItem;
